import PropTypes from "prop-types";
import classnames from "classnames";

import "./formHelper.scss";

const FormHelper = ({ helperText, error, label }) => {
  const errorMessage = error?.message;
  const hasError = typeof error !== "undefined" || errorMessage === "";
  const errorText = errorMessage || `${label} is required.`;

  if (!helperText && !hasError) return;

  return (
    <div
      aria-live="polite"
      className={classnames("form-helper", { "form-helper--error": hasError })}
    >
      {hasError ? errorText : helperText}
    </div>
  );
};

FormHelper.propTypes = {
  helperText: PropTypes.string,
  error: PropTypes.object,
  label: PropTypes.string,
};

export default FormHelper;
